import axios from "axios";
import {getToken} from "../auth/service/authService";
import {BackendUrl} from "../util/config";

const API_BASE = BackendUrl

export async function promoteMembership(
    membershipId: string,
): Promise<any> {
    const token = getToken();
    return await axios.put(
        `${API_BASE}/memberships/${membershipId}/promote`,
        {},
        {
            headers: { Authorization: `Bearer ${token}` },
        }
    );
}